module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAA+klEQVRIS2NkGCDAOED2MuC0+PTFG37//v+bycDAKEG+4/6/YGJkSjfV19iEbgZOi09euPacMkthVv1/YW6gJUmCxdf/gxQL8HEzKMhIMLCxshLt8V+/fzM8ePKC4cOnr2A95gaaGB7E42OIxQZayiRZCnMdyPIL1+6Sb7GZvgbRPkVXeOrijVGL4YFCMI5Hg5qUlDaauJBDazRxwUPj5AVIkTmaneiWnQasdhqw+piUoMWllqyGwKCzWFpChEFSVIjh+et3DE9fvMHrPqr62ERXjYGJiYnh379/DGcu36KmxfhbmcT7mMRW5oC1q6mRqPCZMfi6MLT2MQDsjssffE+o3QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/image/login_icon_phone_default.png
// module id = 106
// module chunks = 30